import { useCustom } from './useCustom';
import { User } from '../store/users/types';

export const useAssignUserRoles = () => {
  const [state, setState] = useCustom();

  const setAssignUserRoles = (_assignUserRoles: User[]) => setState({ _assignUserRoles });
  const assignUserRoles = state._assignUserRoles === undefined ? [] : state._assignUserRoles;

  return { assignUserRoles, setAssignUserRoles };
};